import React from "react";

const VARIANTS = {
  default: { bg: "#FFFFFF", text: "#4A4A52", border: "#E5E5E9" },
  success: { bg: "#ECFDF3", text: "#027A48", border: "#A6F4C5" },
  warning: { bg: "#FFFAEB", text: "#B54708", border: "#FEDF89" },
  error: { bg: "#FEF3F2", text: "#B42318", border: "#FECDCA" },
  info: { bg: "#F0F9FF", text: "#026AA2", border: "#B9E6FE" },
  dark: { bg: "#0A0A0A", text: "#FFFFFF", border: "#0A0A0A" },
};

export default function StatusBadge({ variant = "default", children, testId }) {
  const v = VARIANTS[variant] || VARIANTS.default;
  return (
    <span
      data-testid={testId}
      className="ds-badge"
      style={{ background: v.bg, color: v.text, borderColor: v.border }}
    >
      {children}
    </span>
  );
}

export function ocrStatusVariant(status) {
  switch (status) {
    case "completed":
      return "success";
    case "processing":
    case "pending":
      return "info";
    case "needs_manual_classification":
      return "warning";
    case "failed":
      return "error";
    default:
      return "default";
  }
}

export function docStatusVariant(status) {
  switch (status) {
    case "active":
      return "success";
    case "deletion_requested":
      return "warning";
    case "deleted":
      return "error";
    case "archived":
      return "default";
    default:
      return "default";
  }
}
